<template>
	<div class="footer">
		<div>
			<div class="left">
				<p>
                    办公地址： 河北省石家庄市桥西区城角街611号
				</p>
				<p>
                    E-mail: hbsfjdxh@163.com
				</p>
				<p>
                    邮政编码：050081
				</p>
				<p>
                    版权所有：河北省司法鉴定协会
				</p>
			</div>
			<div class="left">
				<img src="../assets/images/code.png" alt="">
				<img src="../assets/images/code.png" alt="">
				<img src="../assets/images/code.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'index',
		data() {
			return {

			}
		},
		methods: {

		},
		components: {

		},
		computed: {},
		watch: {
		},
		created() {
		}
	};
</script>

<style lang="less" scoped="scoped">
	#app .footer {
	  background: #3B3B3B;
	  &>div {
	    background: #3B3B3B;
	    width: 900px;
	    margin: 0 auto;
	    padding: 30px 0 20px;
	    font-size: 14px;
		overflow: hidden;
		.left{
			width: 50%;
			float: left;
			overflow: hidden;
			img{
				float: right;
				display: block;
				margin-left: 20px;
			}
			p {
			  color: #fff;
			  margin: 15px 0;
			  text-align: left;
			  span {
			    margin: 0 15px;
			  }
			}
		}
	  }
	  @media screen and (max-width: 1024px) {
	    div {
	      width: 100%;
	    }
	  }
	}
</style>
